/**
 * Shared email validation pattern for react-hook-form `pattern` rules.
 *
 * What it checks, over the entire input (anchored `^...$`):
 * - no whitespace anywhere
 * - at least one character before an `@`
 * - a dot somewhere after the `@`, with at least one character on each side
 *   (accepts `user@x.co`, rejects `user@localhost`)
 *
 * Known leniency: `\S` also matches `@` and consecutive dots, so typos like
 * `a@@b.com` or `a@b..com` pass.
 */
export const EMAIL_PATTERN = /^\S+@\S+\.\S+$/;
